import { defineComponent } from "vue";
import { xhrRequest, xhrErrors, xhrSummaryErrors } from "utils/xhr";
import Spinner from "utils/spinner";
import validationErrors from "components/base/validation_errors"
import { Dropzone } from "dropzone";

const onInit = () => { };

const onMounted = function () {
  let csrfToken = document.getElementById('csrf-token');
  var myDropzone = new Dropzone("#upload-container", {
    uploadMultiple: false,
    paramName: "file",
    maxFiles: 1,
    acceptedFiles: "image/png,image/jpeg",
    createImageThumbnails: false,
    success: (file) => {
      let json = JSON.parse(file.xhr.responseText);
      this.user = {
        ...this.user,
        photoUrl: json.url,
        hasPhoto: true
      };
    },
    headers: {
      'X-CSRF-Token': csrfToken.getAttribute('content')
    }
  });
};

const methods = {
  onDeleteClick() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    let spinner = new Spinner();
    xhrRequest(
      "DELETE",
      "UserPhotos",
      {},
      {
        success: (data) => {
          this.user = {
            ...this.user,
            photoUrl: data.url,
            hasPhoto: false
          };
        },
        error: (xhr, status, error) => {
          this.errors = xhrErrors(xhr);
          this.summaryErrors = xhrSummaryErrors(xhr);
        },
        complete: () => {
          spinner.stop();
          this.loading = false;
        }
      }
    );
  },

};

const computed = { };

export default defineComponent({
  template: "#container",
  components: { "validation-errors": validationErrors },
  props: {
    initialUser: {
      type: Object,
      require: true,
    }
  },
  data: function() {
    return {
      loading: false,
      summaryErrors: [],
      errors: {},
      user: this.initialUser,

    }
  },
  created: onInit,
  mounted: onMounted,
  methods: methods,
  computed: computed,
});
